import { useQuery, QueryResult } from '@apollo/client';

import { GetPriceConfigQuery } from '@notino/shared/definitions/types';

import getPriceConfigQuery from './priceConfig.graphql';

export const usePriceConfig = (): QueryResult<GetPriceConfigQuery> => {
  return useQuery<GetPriceConfigQuery>(getPriceConfigQuery);
};
